import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import ChartCard from './ChartCard';

interface StatusPieChartProps {
  data: Array<{
    name: string;
    value: number;
    color: string;
  }>;
  title?: string;
  subtitle?: string;
}

const formatStatusName = (statusName: string): string => {
  const statusMap: Record<string, string> = {
    'ProcessoAtivacaoPortabilidades': 'Processo de Ativacao Portabilidades',
    'ProvisionadoAguardandoEntrega': 'Provisionado Aguardando Entrega',
    'AguardandoCorrecaoConsultor': 'Aguardando Correcao Consultor',
    'AguardandoAnaliseAntiFraude': 'Aguardando Analise Anti Fraude',
    'AguardandoAnaliseGerenteVendas': 'Aguardando Analise Gerente Vendas',
    'AguardandoProcedimentoADM': 'Aguardando Procedimento ADM',
    'AguardandoEmissaoNF': 'Aguardando Emissao NF',
    'AguardandoDocumentacao': 'Aguardando Documentacao',
    'AguardandoEntrega': 'Aguardando Entrega',
    'AguardandoCI': 'Aguardando CI',
    'AguardandoFIDEL': 'Aguardando FIDEL',
    'EmAnaliseBackOffice': 'Em Analise Back Office',
    'EmAnalise': 'Aprovado CQV',
    'Em Análise': 'Aprovado CQV',
  };

  if (statusMap[statusName]) {
    return statusMap[statusName];
  }

  return statusName
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    .trim();
};

const StatusPieChart: React.FC<StatusPieChartProps> = ({ 
  data, 
  title = 'Distribuição de Status',
  subtitle 
}) => {
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      return (
        <div style={{
          background: 'rgba(44, 62, 80, 0.95)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          borderRadius: '8px',
          padding: '12px',
          color: '#fff',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
        }}>
          <p style={{ margin: '0 0 4px 0', fontWeight: 600 }}>{formatStatusName(payload[0].name)}</p>
          <p style={{ margin: 0, color: payload[0].payload.fill }}>
            {payload[0].value} contratos ({payload[0].payload.percentage?.toFixed(1) || '0.0'}%)
          </p>
        </div>
      );
    }
    return null;
  };

  const formattedData = data.map(item => ({
    ...item,
    formattedName: formatStatusName(item.name)
  }));

  return (
    <ChartCard title={title} subtitle={subtitle}>
      <ResponsiveContainer width="100%" height={350}>
        <PieChart>
          <Pie
            data={formattedData}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
          >
            {formattedData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend 
            formatter={(value: string) => {
              const item = formattedData.find(d => d.name === value || d.formattedName === value);
              return item ? item.formattedName : value;
            }}
          />
        </PieChart>
      </ResponsiveContainer>
    </ChartCard>
  );
};

export default StatusPieChart;

